module.exports = __webpack_public_path__ + "img/blue-screen-3.ecbd1b35.webp";